import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const DocumentCheck = ({
  size,
  type,
  theme,
  className,
  dataTestId = "document-check",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M11.1381 8.47136C11.3984 8.21101 11.3984 7.7889 11.1381 7.52856C10.8777 7.26821 10.4556 7.26821 10.1952 7.52856L6.66665 11.0572L5.13805 9.52856C4.8777 9.26821 4.45559 9.26821 4.19524 9.52856C3.93489 9.7889 3.93489 10.211 4.19524 10.4714L6.19524 12.4714C6.45559 12.7317 6.8777 12.7317 7.13805 12.4714L11.1381 8.47136Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.33331 0.666626C2.22874 0.666626 1.33331 1.56206 1.33331 2.66663V13.3333C1.33331 14.4379 2.22874 15.3333 3.33331 15.3333H12.6666C13.7712 15.3333 14.6666 14.4379 14.6666 13.3333V5.99996C14.6666 5.82315 14.5964 5.65358 14.4714 5.52856L9.80472 0.861888C9.67969 0.736864 9.51012 0.666626 9.33331 0.666626H3.33331ZM2.66665 2.66663C2.66665 2.29844 2.96512 1.99996 3.33331 1.99996H8.66665V4.66663C8.66665 5.7712 9.56208 6.66663 10.6666 6.66663H13.3333V13.3333C13.3333 13.7015 13.0348 14 12.6666 14H3.33331C2.96512 14 2.66665 13.7015 2.66665 13.3333V2.66663ZM12.3905 5.33329L9.99998 2.94277V4.66663C9.99998 5.03482 10.2985 5.33329 10.6666 5.33329H12.3905Z"
    />
  </SVGIcon>
);
